import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isDTS } from "../../utility/platform";
import {
  LEGAL_FOOTER_LINKS,
  SWEEPSTAKES_FOOTER_DISCLAIMER,
  RESPONSIBLE_PLAY,
  FOOTER_LEGAL_CMS_IDENTIFIER,
} from "../../utility/complianceCopy";
import { findCmsEntryBySlug } from "../../utility/cmsContent";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import socialone from "../../asset/svg/social1.svg";
import socialtwo from "../../asset/svg/social2.svg";
import socialthree from "../../asset/svg/social3.svg";
import socialfour from "../../asset/svg/social4.svg";
import config from '../config/config';
import {
  FOOTER_SOCIAL_LINKS,
  getBrandAssetsFromSettings,
} from '../../config/brandAssets';
import { COPYRIGHT_LINE } from "../../utility/siteCopy";
import WebsiteBrandLogo from "../common/WebsiteBrandLogo";
import "../../style/compliance.css";

const FOOTER_NAV_COLUMNS = [
  {
    heading: "Company",
    links: [
      { to: "/", label: "Home" },
      { to: "/store", label: "Store" },
      { to: "/faq", label: "FAQ" },
      { to: "/contact_us", label: "Contact Us" },
    ],
  },
  {
    heading: "Account",
    links: [
      { to: "/login", label: "Login" },
      { to: "/signup", label: "Sign Up" },
    ],
  },
];

const HomeFooter = () => {
  const safeParse = (value) => parse(DOMPurify.sanitize(value || ""));

  const [cmsData, setCmsData] = useState({});
  const [siteSetting, setSiteSetting] = useState({});

  const Data = useSelector((state) => state.cmsData);
  // console.log("setCmsData-------->", Data?.cmsData);

  useEffect(() => {
    if (Data) {
      setCmsData(Data?.cmsData)
    }

  }, [Data]);

  const siteData = useSelector((state) => state.settingsData);
  // console.log("siteData-------->", siteData?.settingData);

  useEffect(() => {
    if (siteData) {
      setSiteSetting(siteData?.settingData)
    }

  }, [siteData]);

  const brandAssets = getBrandAssetsFromSettings(siteSetting, config.API_URL);

  // Admin-editable footer legal block (copyright/ownership/disclaimers), same
  // Info Pages CMS flow as Terms/Privacy/Official Rules. Falls back to the
  // hardcoded compliance copy below when the admin hasn't created this page yet.
  const footerLegalCmsEntry = findCmsEntryBySlug(
    cmsData,
    FOOTER_LEGAL_CMS_IDENTIFIER
  );

  return (
    <div className={`footer_bg mt-5 ${isDTS() ? "footer_bg--dts" : "pt-5"}`}>
      {/* PPH keeps its full CMS-driven category footer. DTS uses its own
          Stake.us-style footer below: short nav columns (real routes only,
          no invented categories) + social row + the mandatory compliance
          block (legal links, disclaimers) + brand logo. */}
      {!isDTS() && (
      <Container className="">
        <Row>
          {cmsData?.length > 0 && cmsData?.map((item, key) => {
            // console.log("item", item)f
            if (item?.identifier == 'About us') {
              return (
                <Col key={key} xs={12} sm={6} lg={4} xl={3} className="footer-mobile-center">
                  <h3>{item?.title} </h3>
                  {/* About us */}
                  {/* {cmsData.length > 0 && cmsData?.find((val)=>(val.identifier === 'About us')).title}
          { console.log("val",cmsData?.length > 0 && cmsData?.find((val)=>(val.identifier == 'About us')).title)} */}

                  <p>
                    {safeParse(item?.content)}
                  </p>
                </Col>
              )
            }

            if (item?.identifier == 'Why Play With Us') {
              return (
                <Col key={key} xs={12} sm={6} lg={4} xl={3} className="mt-3 mt-sm-0 footer-mobile-center">
                  <h3>
                    {/* Why Play With Us */}
                    {item?.title}
                  </h3>
                  <p>
                    {safeParse(item?.content)}
                  </p>
                </Col>
              )
            }
            if (item?.identifier == 'Our Services') {
              return (
                <Col key={key} xs={12} sm={6} lg={4} xl={3} className="mt-3 mt-lg-0 footer-mobile-center">
                  <h3>
                    {item?.title}
                    {/* Our Services */}
                  </h3>
                  <p>
                    {safeParse(item?.content)}
                  </p>
                </Col>
              )
            }
            if (item.identifier == 'Contact Us') {
              const wrapPhoneNumbers = (html) => {
                if (!html) return "";
                const phoneRegex = /(\+?\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g;
                return html.replace(phoneRegex, (match) => {
                  return `<a href="tel:${match.replace(/[^\d+]/g, '')}">${match}</a>`;
                });
              };

              return (
                <Col key={key} xs={12} sm={6} lg={4} xl={3} className="mt-3 mt-xl-0 footer-mobile-center footer-contact-col">
                  <h3>
                    {safeParse(item?.title)}
                    {/* Contact Us */}
                  </h3>
                  <div className="footer-contact-content">
                    {safeParse(wrapPhoneNumbers(item?.content))}
                  </div>

                  <div className="d-flex align-items-center gap-3 mb-3">
                    {FOOTER_SOCIAL_LINKS.filter(
                      ({ linkKey }) => siteSetting?.[linkKey]
                    ).map(({ linkKey, iconKey, label }) => (
                      <a
                        key={linkKey}
                        href={siteSetting[linkKey]}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={label}
                      >
                        <img
                          src={brandAssets[iconKey]}
                          alt=""
                          className="img_hvr_eft"
                        />
                      </a>
                    ))}
                  </div>
                </Col>
              )
            }
          })}
        </Row>
      </Container>
      )}

      {/* DTS compliance footer (Stake.us format). Underwriters audit the footer
          first, so the legal links + mandatory sweepstakes disclaimers must be
          present and clickable site-wide. */}
      {isDTS() ? (
        <div className="footer-legal">
          <Container>
            <Row className="footer-nav">
              {FOOTER_NAV_COLUMNS.map((col) => (
                <Col key={col.heading} xs={6} md={4} className="footer-nav__col">
                  <h3 className="footer-nav__heading">{col.heading}</h3>
                  <ul className="footer-nav__list">
                    {col.links.map(({ to, label }) => (
                      <li key={to}>
                        <Link to={to} className="footer-nav__link">
                          {label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
              <Col xs={12} md={4} className="footer-nav__col">
                <h3 className="footer-nav__heading">Legal</h3>
                <ul className="footer-nav__list">
                  {LEGAL_FOOTER_LINKS.map(({ slug, label }) => (
                    <li key={slug}>
                      <Link to={`/info/${slug}`} className="footer-nav__link">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>

            <div className="footer-legal__rule" />

            <div className="footer-social-row">
              {FOOTER_SOCIAL_LINKS.filter(
                ({ linkKey }) => siteSetting?.[linkKey]
              ).map(({ linkKey, iconKey, label }) => (
                <a
                  key={linkKey}
                  href={siteSetting[linkKey]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                >
                  <img
                    src={brandAssets[iconKey]}
                    alt=""
                    className="footer-social-row__icon"
                  />
                </a>
              ))}
            </div>

            <div className="footer-legal__rule" />

            {footerLegalCmsEntry ? (
              // Admin-authored replacement for everything below, entered as
              // formatted content in the Info Pages CMS (identifier
              // "footer-legal-content"). Sanitized the same way as every other
              // CMS-rendered block on this page.
              <div className="footer-legal__cms-content">
                {safeParse(footerLegalCmsEntry.content)}
              </div>
            ) : (
              <>
                <p className="footer-legal__copyright">
                  {COPYRIGHT_LINE(new Date().getFullYear())}
                </p>

                {/* Mandatory: NO PURCHASE NECESSARY + VOID WHERE PROHIBITED. */}
                <p className="footer-legal__fineprint">
                  {SWEEPSTAKES_FOOTER_DISCLAIMER.before}
                  <Link
                    to={`/info/${SWEEPSTAKES_FOOTER_DISCLAIMER.linkSlug}`}
                    className="footer-legal__inline-link"
                  >
                    {SWEEPSTAKES_FOOTER_DISCLAIMER.linkLabel}
                  </Link>
                  {SWEEPSTAKES_FOOTER_DISCLAIMER.after}
                </p>

                {/* Responsible social play resource. */}
                <p className="footer-legal__fineprint">
                  {RESPONSIBLE_PLAY.before}
                  <a
                    href={RESPONSIBLE_PLAY.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-legal__inline-link"
                  >
                    {RESPONSIBLE_PLAY.label}
                  </a>
                </p>
              </>
            )}

            <div className="footer-legal__brand">
              <WebsiteBrandLogo
                asLink={false}
                className="website-brand-logo footer-legal__logo"
              />
            </div>
          </Container>
        </div>
      ) : (
        <div className="copyright py-2">
          <Container>
            <p className="text-center mb-0">
              {COPYRIGHT_LINE(new Date().getFullYear())}
            </p>
          </Container>
        </div>
      )}
    </div>
  );
};

export default HomeFooter;
